"use strict";var a=require("styled-components"),r=e=>(...s)=>a.css`
      ${({theme:i})=>e(i,...s)}
    `;function l(e,s){return(()=>typeof window>"u"||!window.sgBreakpoint?a.css`
        @media (min-width: ${e.breakpoints.md}px) {
          ${s}
        }
      `:typeof window<"u"&&(window.sgBreakpoint==="md"||window.sgBreakpoint==="lg"||window.sgBreakpoint==="xl")?a.css`
        ${s}
      `:a.css``)()}function d(e,s){return(()=>typeof window>"u"||!window.sgBreakpoint?a.css`
        @media (min-width: ${e.breakpoints.lg}px) {
          ${s}
        }
      `:typeof window<"u"&&(window.sgBreakpoint==="lg"||window.sgBreakpoint==="xl")?a.css`
        ${s}
      `:a.css``)()}function h(e,s){return(()=>typeof window>"u"||!window.sgBreakpoint?a.css`
        @media (min-width: ${e.breakpoints.xl}px) {
          ${s}
        }
      `:typeof window<"u"&&window.sgBreakpoint==="xl"?a.css`
        ${s}
      `:a.css``)()}const y=r((e,s)=>l(e,s)),x=r((e,s)=>d(e,s)),m=r((e,s)=>h(e,s));var n={md:y,lg:x,xl:m},v=r((e,s,i)=>a.css`
    ${s}: ${i.map(o=>o==="auto"?`${o} `:o&&o<0?`-${e.spacing.responsive[Math.abs(o)].sm}px `:`${e.spacing.responsive[o].sm}px `)};

    ${n.md(a.css`
      ${s}: ${i.map(o=>o==="auto"?`${o} `:o&&o<0?`-${e.spacing.responsive[Math.abs(o)].md}px `:`${e.spacing.responsive[o].md}px `)};
    `)}

    ${n.lg(a.css`
      ${s}: ${i.map(o=>o==="auto"?`${o} `:o&&o<0?`-${e.spacing.responsive[Math.abs(o)].lg}px `:`${e.spacing.responsive[o].lg}px `)};
    `)}

    ${n.xl(a.css`
      ${s}: ${i.map(o=>o==="auto"?`${o} `:o&&o<0?`-${e.spacing.responsive[Math.abs(o)].xl}px `:`${e.spacing.responsive[o].xl}px `)};
    `)}
  `),u=r(e=>a.css`
      &:focus,
      &:focus-visible,
      &:focus-within {
        outline: none;
        box-shadow: 0 0 0 3px ${e.color.focus.default};
      }
    `);function $(e){const s="cover",i="center",o="no-repeat",p="scroll";return a.css`
    background-size: ${e.size||s};
    background-position: ${e.position||i};
    background-repeat: ${e.repeat||o};
    background-attachment: ${e.attachment||p};
    ${e.src&&`
      background-image: url(${e.src});
    `}
  `}var b=r((e,s)=>a.css`
    ${s.sm&&$(s.sm)}

    ${n.md(a.css`
      ${s.md&&$(s.md)}
    `)}

    ${n.lg(a.css`
      ${s.lg&&$(s.lg)}
    `)}

    ${n.xl(a.css`
      ${s.xl&&$(s.xl)}
    `)}
  `),w=r((e,s=!1)=>{const i=`${e.elevation.size}px ${e.elevation.spread}px ${e.elevation.offset}px ${e.elevation.color}`;return a.css`
    box-shadow: ${s?i:"none"};
  `}),f=r((e,s,i="system")=>{const o=e.getIconProperties(i);return a.css`
    ${o.colorAppliesTo}: ${s};
  `}),k=r((e,s=!1)=>a.css`
    opacity: ${s?e.opacity:"1"};
  `),M=r((e,s,i,o,p)=>a.css`
      ${s}: calc(${i} ${o} ${e.spacing.responsive[p].sm}px);

      ${n.md(a.css`
        ${s}: calc(${i} ${o} ${e.spacing.responsive[p].md}px);
      `)}

      ${n.lg(a.css`
        ${s}: calc(${i} ${o} ${e.spacing.responsive[p].lg}px);
      `)}

      ${n.xl(a.css`
        ${s}: calc(${i} ${o} ${e.spacing.responsive[p].xl}px);
      `)}
    `),B=r((e,s,i)=>{const o=i>0?" ":" -",p=Math.abs(i);return a.css`
    ${s}:${o}${e.spacing.responsive[p].sm}px;

    ${n.md(a.css`
      ${s}:${o}${e.spacing.responsive[p].md}px;
    `)}

    ${n.lg(a.css`
      ${s}:${o}${e.spacing.responsive[p].lg}px;
    `)}

      ${n.xl(a.css`
      ${s}:${o}${e.spacing.responsive[p].xl}px;
    `)}
  `}),z=r((e,s,i)=>a.css`
    ${s}:${e.spacing.responsive[i].sm}px;

    ${n.md(a.css`
      ${s}: ${e.spacing.responsive[i].md}px;
    `)}

    ${n.lg(a.css`
      ${s}: ${e.spacing.responsive[i].lg}px;
    `)}

    ${n.xl(a.css`
      ${s}: ${e.spacing.responsive[i].xl}px;
    `)}
  `),c=r((e,s,i)=>a.css`
    ${i<0&&a.css`
      ${s}: -${e.spacing.responsive[Math.abs(i)].sm}px;

      ${n.md(a.css`
        ${s}: -${e.spacing.responsive[Math.abs(i)].md}px;
      `)}

      ${n.lg(a.css`
        ${s}: -${e.spacing.responsive[Math.abs(i)].lg}px;
      `)}

    ${n.xl(a.css`
        ${s}: -${e.spacing.responsive[Math.abs(i)].xl}px;
      `)}
    `}

    ${i>-1&&a.css`
      ${s}: ${e.spacing.responsive[i].sm}px;

      ${n.md(a.css`
        ${s}: ${e.spacing.responsive[i].md}px;
      `)}

      ${n.lg(a.css`
        ${s}: ${e.spacing.responsive[i].lg}px;
      `)}

    ${n.xl(a.css`
        ${s}: ${e.spacing.responsive[i].xl}px;
      `)}
    `}
  `),S=r(()=>a.css`
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    border: 0;
    padding: 0;
    clip-path: inset(100%);
    clip: rect(0 0 0 0);
    overflow: hidden;
  `),T=r((e,{width:s,style:i,colors:o,position:p="",prefix:g=""})=>{const t=o&&o.outerBorderColor;return!s||!i||!t?(console.error("Please provide a width, style and outerBorderColor value when using the borderGenerator mixin"),a.css``):g?a.css`
        ${g} {
          ${p&&`
          border${`-${p}`}: ${s} ${i} ${t};
        `}
          ${!p&&`
          border: ${s} ${i} ${t};
        `}
        }
      `:a.css`
      ${p&&`
      border${`-${p}`}: ${s} ${i} ${t};
    `}
      ${!p&&`
      border: ${s} ${i} ${t};
    `}
    `});const D=r((e,s,i=!0)=>e.typography.paragraph[s]&&a.css`
      margin: 0;
      font-size: ${e.typography.paragraph[s].fontMobile};
      line-height: ${e.typography.paragraph[s].lineHeightMobile};
      letter-spacing: ${e.typography.paragraph[s].letterSpacingMobile};

      ${i&&c("margin-bottom",e.typography.paragraph[s].marginBottom)}

      ${n.md(a.css`
        font-size: ${e.typography.paragraph[s].fontTablet};
        line-height: ${e.typography.paragraph[s].lineHeightTablet};
        letter-spacing: ${e.typography.paragraph[s].letterSpacingTablet};
      `)}

      ${n.lg(a.css`
        font-size: ${e.typography.paragraph[s].fontDesktop};
        line-height: ${e.typography.paragraph[s].lineHeightDesktop};
        letter-spacing: ${e.typography.paragraph[s].letterSpacingDesktop};
      `)}
    `),H=r((e,s,i=!0)=>e.typography.heading[s]&&a.css`
      margin: 0;
      font-size: ${e.typography.heading[s].fontMobile};
      line-height: ${e.typography.heading[s].lineHeightMobile};
      letter-spacing: ${e.typography.heading[s].letterSpacingMobile};

      ${i&&a.css`
        ${c("margin-bottom",e.typography.heading[s].marginBottom)}
      `}

      ${n.md(a.css`
        font-size: ${e.typography.heading[s].fontTablet};
        line-height: ${e.typography.heading[s].lineHeightTablet};
        letter-spacing: ${e.typography.heading[s].letterSpacingTablet};
      `)}

      ${n.lg(a.css`
        font-size: ${e.typography.heading[s].fontDesktop};
        line-height: ${e.typography.heading[s].lineHeightDesktop};
        letter-spacing: ${e.typography.heading[s].letterSpacingDesktop};
      `)}
    `);var C={heading:H,paragraph:D};exports.advancedSpacing=v;exports.applyFocus=u;exports.backgroundImage=b;exports.createMixin=r;exports.elevation=w;exports.iconAppearance=f;exports.opacity=k;exports.respondTo=n;exports.responsiveCalc=M;exports.responsivePosition=B;exports.responsiveSizing=z;exports.spacing=c;exports.srOnly=S;exports.themedBorderGenerator=T;exports.typography=C;
//# sourceMappingURL=index.cjs.map
